module.exports = __webpack_public_path__ + "static/media/description.f7823105.svg";